
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// import { getAllEmployees } from "../../api/employeeApi";
// import { addUserRole, getAllRoles } from "../../api/userRoleApi";
// import "../../css/CustomTable.css";

// const EmployeeRole = () => {
//   const navigate = useNavigate();

//   const [employees, setEmployees] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [activeEmp, setActiveEmp] = useState(null);
//   const [formData, setFormData] = useState({
//     userName: "",
//     password: "",
//     userRole: "",
//   });

//   useEffect(() => {
//     fetchRoles();
//     fetchEmployees();
//   }, []);

//   const fetchRoles = async () => {
//     try {
//       const roleData = await getAllRoles();
//       console.log("Roles fetched:", roleData);
//       // Use exact casing from API
//       setRoles(roleData.data || roleData);
//     } catch (error) {
//       console.error("Error fetching roles", error);
//     }
//   };

//   const fetchEmployees = async () => {
//     try {
//       const data = await getAllEmployees();
//       setEmployees(data);
//     } catch (error) {
//       console.error("Error fetching employees:", error);
//     }
//   };

//   const handleAddClick = (emp) => {
//     setActiveEmp(emp);
//     setFormData({ userName: "", password: "", userRole: "" }); // fixed typo
//   };

//   const handleSave = async (e) => {
//     e.preventDefault();

//     if (!activeEmp) {
//       alert("Please select an employee by clicking 'Add Role' first.");
//       return;
//     }

//     if (!formData.userName.trim()) {
//       alert("User name is required.");
//       return;
//     }

//     if (!formData.userRole) {
//       alert("Please select a role.");
//       return;
//     }

//     const payload = {
//       employeeID: activeEmp.employeeID,
//       userName: formData.userName,
//       password: formData.password,
//       userRole: parseInt(formData.userRole), // must match RoleID type
//       activateUser: "Yes",
//       crUser: sessionStorage.getItem("username") || "admin1",
//       crDate: new Date().toISOString(),
//       trUser: null,
//       trDate: null,
//       deleted: "N",
//     };

//     try {
//       const result = await addUserRole(payload);
//       alert(result?.message || "Unexpected server response");

//       if (result?.message === "Role added successfully.") {
//         setActiveEmp(null);
//         setFormData({ userName: "", password: "", userRole: "" });
//         fetchEmployees();
//       }
//     } catch (error) {
//       console.error(error);
//       alert(error.message || "Failed to add role.");
//     }
//   };

//   const handleClear = () => {
//     setActiveEmp(null);
//     setFormData({ userName: "", password: "", userRole: "" });
//   };

//   return (
//     <div className="container-fluid p-1">
//       {/* <h4 className="allowance-heading">👤 Employee Role Management</h4> */}
//       <div className="d-flex justify-content-between align-items-center mb-2">
//         <h4 className="allowance-heading">👤 Employee Role Management</h4>
//         <button
//           type="button"
//           className="btn btn-info btn-sm"
//           onClick={() => navigate("/employee/existing-roles")}
//         >
//           View Existing Roles
//         </button>
//       </div>

//       {/* Add Role Form */}
//       <form
//         className="d-flex align-items-end flex-wrap gap-2 mb-3"
//         onSubmit={handleSave}
//         style={{ border: "none", background: "transparent" }}
//       >
//         {/* Employee */}
//         <div style={{ minWidth: "180px" }}>
//           <label className="form-label">Employee</label>
//           <input
//             type="text"
//             className="form-control"
//             value={activeEmp ? activeEmp.fullName : ""}
//             placeholder="Select employee below"
//             disabled
//           />
//         </div>

//         {/* Username */}
//         <div style={{ minWidth: "180px" }}>
//           <label className="form-label">Username</label>
//           <input
//             type="text"
//             className="form-control"
//             value={formData.userName}
//             onChange={(e) =>
//               setFormData({ ...formData, userName: e.target.value })
//             }
//             required
//           />
//         </div>

//         {/* Password */}
//         <div style={{ minWidth: "180px" }}>
//           <label className="form-label">Password</label>
//           <input
//             type="password"
//             className="form-control"
//             value={formData.password}
//             onChange={(e) =>
//               setFormData({ ...formData, password: e.target.value })
//             }
//             required
//           />
//         </div>

//         {/* Role */}
//         <div style={{ minWidth: "180px" }}>
//           <label className="form-label">Role</label>
//           <select
//             className="form-control"
//             value={formData.userRole}
//             onChange={(e) =>
//               setFormData({ ...formData, userRole: e.target.value })
//             }
//             required
//           >
//             <option value="">Select Role</option>
//             {roles.map((role) => (
//               <option key={role.roleID} value={role.roleID}>
//                 {role.roleName}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Buttons */}
//         <div className="d-flex gap-2" style={{ alignSelf: "flex-end" }}>
//           <button type="submit" className="btn btn-success btn-sm">
//             Save
//           </button>
//           <button
//             type="button"
//             className="btn btn-secondary btn-sm"
//             onClick={handleClear}
//           >
//             Cancel
//           </button>
//         </div>
//       </form>

//       {/* Employee Table */}
//       <div className="allowance-table-container">
//         <table className="allowance-table">
//           <thead>
//             <tr>
//               <th>Sr</th>
//               <th>Code</th>
//               <th>Full Name</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {employees.length > 0 ? (
//               employees.map((emp, index) => (
//                 <tr key={emp.employeeID}>
//                   <td>{index + 1}</td>
//                   <td>{emp.employeeCode || "-"}</td>
//                   <td>{emp.fullName}</td>
//                   <td>
//                     <button
//                       className="btn btn-sm btn-primary"
//                       onClick={() => handleAddClick(emp)}
//                     >
//                       Add Role
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="4" className="text-center">
//                   No employees found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default EmployeeRole;





import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getAllEmployees } from "../../api/employeeApi";
import { addUserRole, getAllRoles } from "../../api/userRoleApi";
import "../../css/CustomTable.css";

const EmployeeRole = () => {
  const navigate = useNavigate();

  const [employees, setEmployees] = useState([]);
  const [roles, setRoles] = useState([]);
  const [activeEmp, setActiveEmp] = useState(null);
  const [formData, setFormData] = useState({
    userName: "",
    password: "",
    userRole: "",
  });
  const [searchTerm, setSearchTerm] = useState(""); // <-- NEW

  useEffect(() => {
    fetchRoles();
    fetchEmployees();
  }, []);

  const fetchRoles = async () => {
    try {
      const roleData = await getAllRoles();
      setRoles(roleData.data || roleData);
    } catch (error) {
      console.error("Error fetching roles", error);
    }
  };

  const fetchEmployees = async () => {
    try {
      const data = await getAllEmployees();
      setEmployees(data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const handleAddClick = (emp) => {
    setActiveEmp(emp);
    setFormData({ userName: "", password: "", userRole: "" });
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!activeEmp) {
      alert("Please select an employee by clicking 'Add Role' first.");
      return;
    }

    if (!formData.userName.trim()) {
      alert("User name is required.");
      return;
    }

    if (!formData.userRole) {
      alert("Please select a role.");
      return;
    }

    const payload = {
      employeeID: activeEmp.employeeID,
      userName: formData.userName,
      password: formData.password,
      userRole: parseInt(formData.userRole),
      activateUser: "Yes",
      crUser: sessionStorage.getItem("username") || "admin1",
      crDate: new Date().toISOString(),
      trUser: null,
      trDate: null,
      deleted: "N",
    };

    try {
      const result = await addUserRole(payload);
      alert(result?.message || "Unexpected server response");

      if (result?.message === "Role added successfully.") {
        setActiveEmp(null);
        setFormData({ userName: "", password: "", userRole: "" });
        fetchEmployees();
      }
    } catch (error) {
      console.error(error);
      alert(error.message || "Failed to add role.");
    }
  };

  // ✅ Filter employees by search
  const filteredEmployees = employees.filter((emp) =>
    emp.fullName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleClear = () => {
    setActiveEmp(null);
    setFormData({ userName: "", password: "", userRole: "" });
  };

  return (
    <div className="container-fluid p-1">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h4 className="allowance-heading">👤 Employee Role Management</h4>
        
          <div className="d-flex gap-2 justify-content-end">
            {/*Search Box */}
            <input type="text" className="form-control" style={{ width: "250px" }}
                   placeholder="Search by name..." value={searchTerm}
                   onChange={(e) => setSearchTerm(e.target.value)} />
          </div>
      </div>

      {/* Add Role Form */}
      <form
        className="d-flex align-items-end flex-wrap gap-2 mb-3"
        onSubmit={handleSave}
        style={{ border: "none", background: "transparent" }}
      >
        {/* Employee */}
        <div style={{ minWidth: "180px" }}>
          <label className="form-label">Employee</label>
          <input
            type="text"
            className="form-control"
            value={activeEmp ? activeEmp.fullName : ""}
            placeholder="Select employee below"
            disabled
          />
        </div>

        {/* Username */}
        <div style={{ minWidth: "180px" }}>
          <label className="form-label">Username</label>
          <input
            type="text"
            className="form-control"
            value={formData.userName}
            onChange={(e) =>
              setFormData({ ...formData, userName: e.target.value })
            }
            required
          />
        </div>

        {/* Password */}
        <div style={{ minWidth: "180px" }}>
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            required
          />
        </div>

        {/* Role */}
        <div style={{ minWidth: "180px" }}>
          <label className="form-label">Role</label>
          <select
            className="form-control"
            value={formData.userRole}
            onChange={(e) =>
              setFormData({ ...formData, userRole: e.target.value })
            }
            required
          >
            <option value="">Select Role</option>
            {roles.map((role) => (
              <option key={role.roleID} value={role.roleID}>
                {role.roleName}
              </option>
            ))}
          </select>
        </div>

        {/* Buttons */}
        <div className="d-flex gap-2" style={{ alignSelf: "flex-end" }}>
          <button type="submit" className="btn btn-success btn-sm">
            Save
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={handleClear}
          >
            Cancel
          </button>
          <button
          type="button"
          className="btn btn-info btn-sm"
          onClick={() => navigate("/employee/existing-roles")}
        >
          View Existing Roles
        </button>
        </div>
      </form>

      {/* Employee Table */}
      <div className="allowance-table-container">
        <table className="allowance-table">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Code</th>
              <th>Full Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredEmployees.length > 0 ? (
              filteredEmployees.map((emp, index) => (
                <tr key={emp.employeeID}>
                  <td>{index + 1}</td>
                  <td>{emp.employeeCode || "-"}</td>
                  <td>{emp.fullName}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => handleAddClick(emp)}
                    >
                      Add Role
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No employees found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployeeRole;
